import { HOURS, IMG, SERVICES } from "@/data/site";

export const SaloonHero = () => (
  <section className="relative overflow-hidden border-b border-slate-800" data-testid="saloon-hero-section">
    <div className="absolute inset-0">
      <img src={IMG.salonHero} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-slate-950/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8 dir3-animate">
          <div className="inline-flex items-center gap-3 mb-6" data-testid="hero-tagline">
            <span className="h-px w-8 bg-rose-500" />
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-rose-300">Fancy Saloon <span className="text-white mx-1">×</span> Zoryven Hair Care</span>
          </div>
          <h1 className="font-condensed text-5xl sm:text-7xl lg:text-8xl uppercase tracking-tight text-white leading-[0.95]">
            Fancy<br />Saloon
          </h1>
          <p className="text-base sm:text-lg text-slate-200 font-medium italic mt-5 max-w-xl" data-testid="hero-tagline-sub">Where hair care meets hair wellness.</p>
          <p className="text-base sm:text-lg text-slate-300 font-light leading-relaxed mt-3 max-w-2xl">
            Unisex haircuts, beard grooming, colour, spa, facials and nail rituals in Sogam, Lolab — finished with Zoryven repair and nourishing treatments.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mt-10">
            <a href="#contact" data-testid="hero-book-btn" className="px-8 py-4 bg-rose-600 hover:bg-rose-500 text-white font-bold uppercase tracking-wider text-xs rounded-xl text-center transition-colors shadow-lg shadow-rose-600/20">
              Book Appointment Slot
            </a>
            <a href="#services-grid" data-testid="hero-services-btn" className="px-8 py-4 bg-slate-900/80 hover:bg-slate-800 border border-slate-700 text-slate-200 font-semibold uppercase tracking-wider text-xs rounded-xl text-center transition-colors">
              Browse All {SERVICES.length} Services
            </a>
          </div>
        </div>
        <div className="lg:col-span-4 grid grid-cols-2 gap-3 text-xs">
          <div className="p-5 rounded-2xl bg-slate-900/70 border border-slate-800 backdrop-blur">
            <div className="font-condensed text-3xl text-white">{SERVICES.length}</div>
            <div className="text-slate-400 mt-1">Signature services</div>
          </div>
          <div className="p-5 rounded-2xl bg-slate-900/70 border border-slate-800 backdrop-blur">
            <div className="font-condensed text-3xl text-rose-400">₹50</div>
            <div className="text-slate-400 mt-1">Hair cut from</div>
          </div>
          <div className="col-span-2 p-5 rounded-2xl bg-slate-900/70 border border-slate-800 backdrop-blur">
            <span className="text-[11px] font-bold text-rose-400 uppercase tracking-wider">Unisex Salon</span>
            <p className="text-slate-300 mt-1" data-testid="hero-hours">{HOURS} &bull; Walk-ins &amp; telephone appointments</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
